export default {
  title: 'Bibliothèques'
}



// WEBPACK FOOTER //
// ./src/translations/fr/libraries.js